<template>
  <div class="c-share">
    <button
      @click="openShare('facebook')"
      data-sharer="facebook"
      data-hashtag="hashtag"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/facebookShare.png">
    </button>
    <button
      @click="openShare('twitter')"
      data-sharer="twitter"
      data-hashtag="hashtag"
      :data-via="originApp"
      :data-title="shareTitle"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/twitterShare.png">
    </button>
    <button
      @click="openShare('sina')"
      data-sharer="weibo"
      :data-title="`【（分享来自 @人民日报英文客户端 ）]${shareTitle}`"
      :data-image="sharePicture"
      :data-url="localUrl"
    >
      <img src="/src/assets/share/weiboShare.png">
    </button>
  </div>

</template>

<script setup lang="ts">
import { typeViteEnv } from '@/utils/env'
import { useStore } from '@gx-vuex'

const store = useStore()

const localUrl = computed(() => location.href)

const shareTitle = ref('')
const sharePicture = ref('')

const originApp = ref(typeViteEnv('VITE_BASE_APP_ORIGIN'))

// const contentId = document.querySelector('body').getAttribute('data-id')
const objectType = document.querySelector('body').getAttribute('data-objectType')

const openShare = (type: string) => {
  store.point.shareClick(type, Number(objectType))
}

onMounted(() => {
  try {
    shareTitle.value = shareInfo?.shareTitle
    sharePicture.value = shareInfo?.fullUrl || ''
    window.Sharer && window.Sharer?.init()
  } catch (e) {}
})
</script>

<style lang="less" scoped>
.c-share {
  display: flex;
  gap: 16px;
  
  button {
    width: 24px;
    height: 24px;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    
    img {
      width: 24px;
      height: 24px;
    }
  }
}

</style>
